import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

/**
 * A custom element that displays a product price.
 * FIX: Includes logic to strip leading zeros automatically.
 */
class ProductPrice extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);

    // FIX: Sofort beim Laden einmal reinigen
    this.cleanPrice(this.querySelector('[ref="priceContainer"]'));
    
    // Beobachter starten, falls sich der Inhalt später ändert (z.B. durch andere Skripte)
    this.observer = new MutationObserver(() => {
        this.cleanPrice(this.querySelector('[ref="priceContainer"]'));
    });
    this.observer.observe(this, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
    if (this.observer) this.observer.disconnect();
  }

  /**
   * Updates the price.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newPrice = event.detail.data.html.querySelector('product-price [ref="priceContainer"]');
    const currentPrice = this.querySelector('[ref="priceContainer"]');

    if (!newPrice || !currentPrice) return;

    // FIX: Das neue Element bereinigen, BEVOR es eingefügt wird
    this.cleanPrice(newPrice);

    if (currentPrice.innerHTML !== newPrice.innerHTML) {
      currentPrice.replaceWith(newPrice);
    }
  };

  /**
   * Hilfsfunktion: Sucht und vernichtet führende Nullen im Text
   */
  cleanPrice(container) {
    if (!container) return;

    // Suche nach Preiselementen innerhalb des Containers
    const priceElements = container.querySelectorAll('.price, .money, span');
    
    // Auch den Container selbst prüfen, falls der Text direkt drin steht
    const elementsToCheck = [container, ...priceElements];

    elementsToCheck.forEach(el => {
        // Nur Textknoten bearbeiten, um HTML-Tags nicht zu zerstören
        el.childNodes.forEach(node => {
            if (node.nodeType === 3) { // 3 = Text Node
                let text = node.nodeValue;
                // Regex: Suche nach 0 am Anfang oder nach Leerzeichen/Währungssymbol, gefolgt von einer Ziffer
                // Beispiel: "035" -> "35", "€035" -> "€35", "€ 035" -> "€ 35"
                if (text && (text.match(/^\s*0\d/) || text.match(/[\s€]0\d/))) {
                     // Ersetze "0" gefolgt von Ziffer (1-9) durch die Ziffer selbst
                     const newText = text.replace(/(\s|€|^)0([1-9])/g, '$1$2');
                     if (newText !== text) {
                         node.nodeValue = newText;
                     }
                }
            }
        });
    });
  }
}

if (!customElements.get('product-price')) {
  customElements.define('product-price', ProductPrice);
}